<div class="snack-bar">
    <div class="profile">
        <img id="icon" [src]="data.image" alt="">
        <p [innerHTML]="data.description"></p>
    </div>
</div>